module.exports = __webpack_public_path__ + "a3ce10e53b60c54069bd54a2bc6794b6.jpg";